<script setup lang="ts">
import { RemoveHotelSelectionFiltersOrigin } from '@apps/main/new-desktop/core/models';
import { CloseHotelSelectionFiltersOrigin } from '@apps/main/new-desktop/core/models/statsigEvents/statsigEventsMetadata';
import { usePaxStore } from '@apps/main/new-desktop/core/stores/pax/paxStore';
import HotelSelectionFiltersFooter from '@apps/main/new-desktop/pages/hotelSelection/components/HotelSelectionFiltersFooter.vue';
import { HotelFiltersModal } from '@apps/main/new-desktop/modules/hotelFilters';
import { useFiltersStore } from '@apps/main/new-desktop/core/stores/filters/filtersStore';
import { useEditingIngredientStore } from '@apps/main/new-desktop/core/stores';

import { DestinationSelectorModal } from '../../../modules/destinationSelector';
import { PaxSelectorModal } from '../../../modules/paxSelector';
import { WhyWeSuggestModal } from '../../../modules/suggestionTypeSelector';
import { SemboBenefitsModal } from '../../../modules/semboBenefits';
import { HotelSelectionModalType } from '../models/hotelSelectionModals';
import {
  useHotelSelectionModalsStore,
  useHotelSelectionStore,
} from '../stores';
import { useHotelSelectionDestinationSelectorStore } from '../stores/destinationSelector/destinationSelectorStore';

import PeekPriceModal from './peekPriceModal/PeekPriceModal.vue';

const hotelSelectionModalsStore = useHotelSelectionModalsStore();
const hotelSelectionStore = useHotelSelectionStore();
const destinationSelectorStore = useHotelSelectionDestinationSelectorStore();
const paxStore = usePaxStore();
const editingIngredientStore = useEditingIngredientStore();
const filtersStore = useFiltersStore();
</script>

<template>
  <HotelFiltersModal
    v-if="
      hotelSelectionModalsStore.hotelSelectionModalType ===
      HotelSelectionModalType.MobileFiltersModal
    "
    :header-text="$t('filter.header')"
    :ingredient="editingIngredientStore.editingStayIngredient"
    @close="hotelSelectionModalsStore.closeHotelSelectionModal($event)"
    @update-filter="
      filtersStore.updateHotelFilter(
        $event,
        RemoveHotelSelectionFiltersOrigin.FilterList
      )
    "
  >
    <template #footer>
      <HotelSelectionFiltersFooter
        :is-loading="hotelSelectionStore.shouldDisplayLoader"
        :hotels-amount="hotelSelectionStore.hotelSelectionCards.length"
        @reset-filters="hotelSelectionStore.resetAllFilters"
        @confirm-filters="
          hotelSelectionModalsStore.closeHotelSelectionModal(
            CloseHotelSelectionFiltersOrigin.ShowResultsButton
          )
        "
      />
    </template>
  </HotelFiltersModal>

  <PaxSelectorModal
    v-if="
      hotelSelectionModalsStore.hotelSelectionModalType ===
      HotelSelectionModalType.PaxSelector
    "
    :initial-paxes="paxStore.initialPaxes"
    :should-show-tickets-warning="paxStore.shouldShowTicketsWarning"
    :should-show-room-selection-warning="
      paxStore.shouldShowRoomSelectionWarning
    "
    :should-show-number-of-vehicles-updated-warning="false"
    :should-show-number-of-vehicles-will-be-updated-warning="
      paxStore.shouldShowNumberOfVehiclesWillBeUpdatedWarning
    "
    @confirm-modal="hotelSelectionModalsStore.confirmPaxSelectorModal"
    @cancel-modal="hotelSelectionModalsStore.closeHotelSelectionModal"
  />

  <WhyWeSuggestModal
    v-if="
      hotelSelectionModalsStore.hotelSelectionModalType ===
      HotelSelectionModalType.WhyWeSuggest
    "
    @close="hotelSelectionModalsStore.closeHotelSelectionModal"
  />

  <DestinationSelectorModal
    v-if="
      hotelSelectionModalsStore.hotelSelectionModalType ===
      HotelSelectionModalType.DestinationSelector
    "
    :search-text="destinationSelectorStore.searchText"
    @close-modal="hotelSelectionModalsStore.closeHotelSelectionModal"
    @change-destination="
      hotelSelectionModalsStore.confirmDestinationSelectorModal
    "
  />
  <SemboBenefitsModal
    v-if="
      hotelSelectionModalsStore.hotelSelectionModalType ===
      HotelSelectionModalType.SemboBenefits
    "
    @close-modal="hotelSelectionModalsStore.closeHotelSelectionModal"
  />

  <PeekPriceModal
    v-if="
      hotelSelectionModalsStore.hotelSelectionModalType ===
      HotelSelectionModalType.PeekPrice
    "
    @confirm="hotelSelectionModalsStore.confirmPeekPriceModal()"
    @cancel="hotelSelectionModalsStore.closePeekPriceModal()"
  />
</template>
